import { useDispatch, useSelector } from 'react-redux';
import Devices from 'redux/Devices';
import Fields from 'redux/Fields';
import Notifications from 'redux/Notifications';
import _ from 'lodash';

const useDevices = () => {
  const dispatch = useDispatch();

  const isFetchingDevices = useSelector(Devices.getIsFetchingDevices);

  const devices = useSelector(Devices.getDevices);
  const selectedDevices = useSelector(Devices.getSelectedDevices);
  const selectedDevice = useSelector(Devices.getActiveDevice);
  const getDevicesWithFieldNameList = useSelector(Devices.getDevicesWithFieldNameList);
  const activeFieldDevices = useSelector(Fields.getFieldDevices);

  const setSelectedDevice = (probe) => {
    dispatch(Devices.startFetch());
    return dispatch(Devices.setSelectedDevice(probe));
  };

  const getFieldDevices = (field) => {
    let fieldDevices = [];
    if (field && field.id) {
      fieldDevices = _.filter(devices, { field_id: field.id });
    } else {
      fieldDevices = devices;
    }
    return fieldDevices;
  };

  const fetchDevices = (organizationId) => {
    if (!isFetchingDevices) {
      dispatch(Devices.startFetch());
      return dispatch(Devices.fetchDevices(organizationId)).catch((err) => {
        dispatch(Notifications.setError(err));
      });
    }
  };

  const saveDevices = (devices) => {
    if (devices) {
      dispatch(Devices.startFetch());
      if (devices.device_id.length > 0 && devices.device_id[0] !== undefined) {
        return dispatch(Devices.updateDevices(devices)).catch((err) => {
          dispatch(Notifications.setError(err));
        });
      } else if (devices.device_id[0] === undefined) {
        return dispatch(Devices.createDevice(devices)).catch((err) => {
          dispatch(Notifications.setError(err));
        });
      }
    }
  };

  return {
    devices,
    getDevicesWithFieldNameList,
    activeFieldDevices,
    selectedDevice,
    selectedDevices,

    getFieldDevices,
    setSelectedDevice,
    fetchDevices,

    saveDevices,
  };
};

export default useDevices;
